// Local imports
import { PRODUCT as SGHOME_DATALAYER } from '../../datalayer/data/donation.js';
import * as event from '../../datalayer/event.js';

// Product is an object that contains only the following attributes:
// * id
// * name
// * category_name
// * sku
// * variants
// * price
// * img_url
export function update_sghome_datalayer(product, ispromo, position, listname) {
    SGHOME_DATALAYER.is_promo = ispromo;

    // Tealium Data Layer for impression on donation products.
    SGHOME_DATALAYER.category.push(product.category_name);
    SGHOME_DATALAYER.id.push(product.id);
    SGHOME_DATALAYER.name.push(product.name);
    SGHOME_DATALAYER.list_position.push(position);
    SGHOME_DATALAYER.list_name.push(listname);
    SGHOME_DATALAYER.price.push(product.price);

    if (ispromo === 'true') {
        SGHOME_DATALAYER.promo_id.push(product.id);
        SGHOME_DATALAYER.promo_name.push(product.title);
        SGHOME_DATALAYER.promo_creative.push(product.img_url);
        SGHOME_DATALAYER.promo_position.push(position);
    } else {
        SGHOME_DATALAYER.promo_id.push('');
        SGHOME_DATALAYER.promo_name.push('');
        SGHOME_DATALAYER.promo_creative.push('');
        SGHOME_DATALAYER.promo_position.push('');
    }

    // These are not added to utag_data
    SGHOME_DATALAYER.list_variant.push(product.variants);
    SGHOME_DATALAYER.sku.push(product.sku);

    global.productImpressions.push({
        item_name: product.name,
        item_id: product.id,
        price: product.price,
        item_category: product.category_name,
        item_variant: product.variants,
        item_list_name: 'Donations',
        index: position,
    });

    global.uaProductImpressions.push({
        name: product.name,
        id: product.id,
        price: product.price,
        category: product.category_name,
        variant: product.variants,
        list: listname,
        position: position,
    });
}

// footer is an object that contains only the following attributes:
// * id
// * name
// * img_url
// * position
export function update_sghome_footer_datalayer(footer) {
    SGHOME_DATALAYER.promo_id.push(footer.id);
    SGHOME_DATALAYER.promo_name.push(footer.name);
    SGHOME_DATALAYER.promo_creative.push(footer.img_url);
    SGHOME_DATALAYER.promo_position.push(footer.position);
}

// This assumes window.utag_data exists
//
// click is an object that contains the following attributes:
// * total
// * name
// * creative
// * position
export function update_sghome_footerclick_datalayer(global, click) {
    let utag_data = global.utag_data;
    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Promo Click';
    utag_data['event_label'] = ' Promo ';

    utag_data['promo_ids'] = '';
    utag_data['promo_names'] = click.name;
    utag_data['promo_creatives'] = click.creative;
    utag_data['promo_positions'] = click.position;
}

// This assumes window.utag_data exists
//
// promo is an object that contains the following attributes:
// * id
// * name
// * creative
// * position
//
// product is an object that contains the following attributes:
// * id
// * price
// * name
// * listname
// * position
export function update_sghome_click_datalayer(global, ispromo, promo, product) {
    let utag_data = global.utag_data;
    utag_data['event_category'] = 'Ecommerce';

    if (ispromo) {
        update_sghome_click_datalayer_promo(global, utag_data, promo);
    } else {
        update_sghome_click_datalayer_product(global, utag_data, product);
    }
}

function update_sghome_click_datalayer_promo(global, utag_data, promo) {
    utag_data['event_action'] = 'Promo Click';
    utag_data['event_label'] = 'Promo';
    utag_data['promo_ids'] = promo.id;
    utag_data['promo_names'] = promo.name;
    utag_data['promo_creatives'] = promo.creative;
    utag_data['promo_positions'] = promo.position;

    event.dispatch(global, event.EventKind.PromoClick);
}

function update_sghome_click_datalayer_product(global, utag_data, product) {
    utag_data['event_action'] = 'Product Click';
    utag_data['event_label'] = 'Donation';
    utag_data['product_price'] = product.price;
    utag_data['product_id'] = product.id;
    utag_data['product_name'] = product.name;
    utag_data['product_brand'] = 'One Time Donation';
    utag_data['product_variant'] = '';
    utag_data['product_category'] = 'Donation/ / ';
    utag_data['product_quantity'] = '1';
    utag_data['product_list'] = product.listname;
    utag_data['product_position'] = product.position;
    utag_data['enh_action'] = 'click';

    event.dispatch(global, event.EventKind.ProductClick);
}
